// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import get from 'lodash/get';
import cx from 'classnames';
// Components
import CompanyCard from '../../components/СompanyСard/CompanyCard';
import {
  brokerCommunityLogo,
  imageModifierTypes,
  language,
  PROFESSIONALS_TYPES
} from '../../constants';
import appendLocale from '../../helpers/appendLocale';
import modifyImageLink from '../../utils/modifyImageLink';
import styles from './ProfessionalsList.scss';

import realtorsAssociationLogo from '../../../static/images/realtors_association_logo.png';

const brokerDescriptionHe = 'רשת ברוקר הינה קהילת הנדל"ן האיכותית ביותר בישראל, הרשת מונה כיום למעלה מ - 100 נקודות שירות ובכל נקודה בארץ.';
const realtorsAssociationDescriptionHe = {
  he: 'החברות בלשכת מתווכי הנדל“ן הארצית מעמידה אתכם בשורה הראשונה והאיכותית של מתווכי הנדל“ן בישראל. הלשכה פועלת באופן נמרץ להעלות את תדמיתו של המתווך החבר בלשכה ״כמתווך מקצוען בעל ידע רב והמחוייב לכללי האתיקה של הארגון״. הלשכה מעצימה ומבדלת את חבריה במגוון מדיות לציבור הרחב.',
  en: 'The companies in the National Real Estate Brokers Association place you at the forefront of high-quality real estate brokers in Israel. The office works diligently to enhance the reputation of its affiliated broker as “a professional broker with extensive knowledge and commitment to the organization’s ethical principles.” The office empowers and distinguishes its members through various media channels for the general public.',
  ru: 'Компании в Национальной ассоциации риэлторов представляют вас в первом и качественном ряду недвижимостных риэлторов в Израиле. Ассоциации риэлторов работает усердно, чтобы повысить репутацию своих аффилированных риэлторов как “профессионалов с обширными знаниями и приверженностью этическим принципам организации“. Ассоциации риэлторов укрепляет и выделяет своих членов через различные медиа-каналы для широкой публики.',
  fr: 'Les entreprises de l’Association nationale des courtiers immobiliers vous placent en première ligne et de qualité parmi les courtiers immobiliers en Israël. Le bureau travaille avec diligence pour améliorer la réputation du courtier affilié en tant que “courtier professionnel avec une connaissance approfondie et engagé envers les principes éthiques de l’organisation”. Le bureau renforce et distingue ses membres à travers divers médias pour le grand public.'
};

export default class ProfessionalsList extends Component {
  renderList = () => {
    const { locale, translate } = this.props;

    return this.props.professionals && this.props.professionals.map((item, idx) => {
      const nameInCurrentLocale = get(item, `name[${locale}]`);
      const descriptionInCurrentLocale = get(item, `description[${locale}]`);
      const titleInCurrentLocale = get(item, `title[${locale}]`);

      const name = nameInCurrentLocale || get(item, `name[${language.default}]`);
      const description = descriptionInCurrentLocale || get(item, `description[${language.default}]`);
      const title = titleInCurrentLocale || get(item, `title[${language.default}]`);

      return (
        <CompanyCard
          link={appendLocale(this.props.locale, `/company/${item.id}`)}
          translate={translate}
          id={item.id}
          key={item.id}
          logo={modifyImageLink(item.image, imageModifierTypes.LOGO)}
          name={name}
          title={title}
          description={description}
          count={item.properties_count}
          nameInCurrentLocale={!nameInCurrentLocale}
          descriptionAtDefaultLang={!descriptionInCurrentLocale}
          // clickHandler={() => this.handleClick(item.id)}
          withoutCount={item.type !== PROFESSIONALS_TYPES.AGENCY}
          isLink
        />
      );
    });
  };

  renderCards = () => {
    const { translate, isProfessionals, isBroker, companyNameForFilter, currentCompanyType } = this.props;
    const brokerCommunityTitle = translate('title', 'brokerCommunity').toString();
    const realtorsAssociationTitle = translate('title', 'realtorsAssociation').toString();

    return (
      <div className={cx(styles.professionalsList, { [styles.brokerList]: isBroker })}>
        {
          isProfessionals
          && currentCompanyType === PROFESSIONALS_TYPES.AGENCY
          && (!companyNameForFilter || brokerCommunityTitle.match(RegExp(companyNameForFilter, 'i'))) && (
          <CompanyCard
            link={appendLocale(this.props.locale, '/professionals/broker')}
            translate={translate}
            id="brokerCommunityLink"
            key="brokerCommunityLink"
            logo={brokerCommunityLogo}
            title={brokerCommunityTitle}
            name={brokerCommunityTitle}
            description={brokerDescriptionHe}
            descriptionAtDefaultLang
            withoutCount
            isBroker
          />
        )}
        {
          isProfessionals
          && currentCompanyType === PROFESSIONALS_TYPES.AGENCY
          && (!companyNameForFilter || brokerCommunityTitle.match(RegExp(companyNameForFilter, 'i'))) && (
          <CompanyCard
            link={appendLocale(this.props.locale, '/professionals/realtors-association')}
            translate={translate}
            id="realtorsAssociationLink"
            key="realtorsAssociationLink"
            logo={realtorsAssociationLogo}
            name={realtorsAssociationTitle}
            description={realtorsAssociationDescriptionHe[this.props.locale]}
            descriptionAtDefaultLang
            withoutCount
            isRealtorsAssociation
          />
        )}
        {this.renderList()}
      </div>
    );
  }

  render() {
    const { isProfessionals } = this.props;

    return (
      isProfessionals ? (
        <InfiniteScroll
          className={styles.cardsWrapper}
          loadMore={this.props.loadMore}
          threshold={500}
          hasMore={this.props.hasMore}
          loader={<div className="loader" key={0}>Loading ...</div>}
        >
          {this.renderCards()}
        </InfiniteScroll>
      ) : (this.renderCards())
    );
  }
}

ProfessionalsList.propTypes = {
  isMobile: PropTypes.bool,
  locale: PropTypes.string,
  companyNameForFilter: PropTypes.string,
  professionals: PropTypes.array,
  isProfessionals: PropTypes.bool,
  isBroker: PropTypes.bool,
  translate: PropTypes.func,
  loadMore: PropTypes.func,
  hasMore: PropTypes.bool,
  currentCompanyType: PropTypes.string
};
